var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{attrs:{"pills":""}},_vm._l((_vm.categories),function(category){return _c('b-tab',{key:category.value,attrs:{"title":category.text}},[_c(category.component,{tag:"component"})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }